import React from 'react';
import { RowKey } from 'react-base-table';

import useMicroSkillsDetails from '@/modules/skill-matrix/views/SkillsManager/components/Dialogs/components/SkillsDetails/components/MicroSkillsDetails/hooks/useMicroSkillsDetails';
import { SkillWithMicroSkillDetailsFragment } from '@/modules/skill-matrix/views/SkillsManager/components/Dialogs/components/SkillsDetails/graphql/query/generated/skillMicroSkillDetails';
import MicroSkillsTableView from '@/modules/skill-matrix/views/SkillsManager/components/MicroSkillsTableView';
import {
  getMicroSkillsNameColumn,
  getMicroSkillsSelectColumn,
} from '@/modules/skill-matrix/views/SkillsManager/components/MicroSkillsTableView/getColumns';

interface MicroSkillsTableProps {
  skills?: SkillWithMicroSkillDetailsFragment[];
  toggle: (id: string) => void;
  selectedSkillIds: string[];
  expandedKeys?: RowKey[];
  setExpandedKeys?: (keys: RowKey[]) => void;
}

const COLUMNS = [getMicroSkillsNameColumn(), getMicroSkillsSelectColumn()];

function MicroSkillsTable(props: MicroSkillsTableProps) {
  const { skills, selectedSkillIds, toggle, expandedKeys, setExpandedKeys } = props;
  const { state, onFetchChildMicroSkill } = useMicroSkillsDetails({
    childSkills: skills,
  });

  return (
    <MicroSkillsTableView
      actions={{
        fetchMicroSkills: onFetchChildMicroSkill,
        toggleMicroSkillSelection: ({ id }) => toggle(id),
      }}
      className="w-full"
      columns={COLUMNS}
      expandedKeys={expandedKeys}
      hierarchyMicroSkillsMap={state.hierarchyIdsMap}
      microSkillsMap={state.microSkillsMap}
      rootMicroSkillIds={state.rootMicroSkillIds}
      uiState={{
        selectedSkillIds,
      }}
      onExpandedKeysChange={setExpandedKeys}
    />
  );
}

export default MicroSkillsTable;
